import { Box, styled } from "@mui/material";

export const CouponComp = styled(Box)(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    height: '112px',
    border: 'solid 1px #BDBDBD',
    borderRadius: theme.shape.borderRadius,
    width: "90%"
}))

export const TextCoupon = styled('p')(({ theme }) => (props) => ({
    fontSize: '14px',
    fontWeight: '700',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
    }
}))